import React, { createContext, useReducer, useContext, useCallback, useMemo, useRef } from "react";
import { savedContractsReducer } from "./savedContractsReducer";
import { initialStore } from "./initialStore";
import * as actionTypes from "./actionTypes";

export const SavedContractsContext = createContext(null);

export function SavedContractsProvider({ children, initialState = {} }) {
  const [state, dispatch] = useReducer(savedContractsReducer, {
    ...initialStore,
    ...initialState,
  });

  const stateRef = useRef(state);
  stateRef.current = state;

  const setCalculatorData = useCallback((payloadOrUpdater) => {
    const payload =
      typeof payloadOrUpdater === "function"
        ? payloadOrUpdater(stateRef.current.calculatorData)
        : payloadOrUpdater;
    dispatch({ type: actionTypes.SET_CALCULATOR_DATA, payload });
  }, []);

  const setSelectedVessels = useCallback(
    (payload) => dispatch({ type: actionTypes.SET_SELECTED_VESSELS, payload }),
    []
  );

  const setPortOperations = useCallback(
    (payload) => dispatch({ type: actionTypes.SET_PORT_OPERATIONS, payload }),
    []
  );

  const setFleetList = useCallback(
    (payload) => dispatch({ type: actionTypes.SET_FLEET_LIST, payload }),
    []
  );

  const setSelectedQuery = useCallback(
    (payload) => dispatch({ type: actionTypes.SET_SELECTED_QUERY, payload }),
    []
  );

  const setSyncBunker = useCallback(
    (payload) => dispatch({ type: actionTypes.SET_SYNC_BUNKER, payload }),
    []
  );

  const setIsOverride = useCallback(
    (payload) => dispatch({ type: actionTypes.SET_IS_OVERRIDE, payload }),
    []
  );

  const setEstimationEstId = useCallback(
    (payload) => dispatch({ type: actionTypes.SET_ESTIMATION_EST_ID, payload }),
    []
  );

  const setSplitHireArray = useCallback(
    (payload) => dispatch({ type: actionTypes.SET_SPLIT_HIRE_ARRAY, payload }),
    []
  );

  const setPortDistanceResponse = useCallback(
    (payload) => dispatch({ type: actionTypes.SET_PORT_DISTANCE_RESPONSE, payload }),
    []
  );

  const setRealPortDistanceResponse = useCallback(
    (payload) => dispatch({ type: actionTypes.SET_REAL_PORT_DISTANCE_RESPONSE, payload }),
    []
  );

  const setPortDistancePayloadResponse = useCallback(
    (payload) => dispatch({ type: actionTypes.SET_PORT_DISTANCE_PAYLOAD_RESPONSE, payload }),
    []
  );

  const resetStore = useCallback(
    () => dispatch({ type: actionTypes.RESET_STORE }),
    []
  );

  const value = useMemo(
    () => ({
      ...state,
      dispatch,
      setCalculatorData,
      setSelectedVessels,
      setPortOperations,
      setFleetList,
      setSelectedQuery,
      setSyncBunker,
      setIsOverride,
      setEstimationEstId,
      setSplitHireArray,
      setPortDistanceResponse,
      setRealPortDistanceResponse,
      setPortDistancePayloadResponse,
      resetStore,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );

  return (
    <SavedContractsContext.Provider value={value}>
      {children}
    </SavedContractsContext.Provider>
  );
}

export function useSavedContractsContext() {
  const context = useContext(SavedContractsContext);
  if (!context) {
    throw new Error(
      "useSavedContractsContext must be used within a SavedContractsProvider"
    );
  }
  return context;
}
